// extracted by mini-css-extract-plugin
export default {"deleteOverlay":"M4-z","cancel":"N4-z","disabled":"O4-z","delete":"P4-z"};